import { UserMatrixRowModel } from '../user-matrix-row-model';

export class MatrixRowModel {
    userMatrixRowId: string;
    userMatrixId: string;
    jointId: string;
    calculationType: string;
    calculationDate: string;
    pressureClassName: string;
    pipeSize: string;
    gasketName: string;
    residualBoltLoad: string;
    residualBoltStress: string;
    tighteningMethod: string;
    toolName: string;
    toolPressure: string;
    userMatrixRow: UserMatrixRowModel;
}
